import { DocumentNode, Kind, OperationDefinitionNode } from 'graphql';
import { hashCode } from './hashCode';

export const apolloHash = (documentNode: DocumentNode, variables: Record<string, any>) => {
  const opDef: OperationDefinitionNode = documentNode.definitions.find(
    d => d.kind === Kind.OPERATION_DEFINITION,
  ) as OperationDefinitionNode;
  return hashCode(`${opDef.name?.value}${JSON.stringify(variables || {})}`);
};
